import styles from "./Chip.module.scss";

/**
 * Chip component
 * @param {{
 *   text: string,
 *   variant?: "danger"|"success"|"warning"|"info",
 *   className?: string,
 *   icon?: JSX.Element
 * }} props
 * @returns {JSX.Element} Chip
 */
function Chip({ text, variant = "info", className, icon }) {
  return <div className={`${styles["chip"]} ${styles[`chip--${variant}`]} ${className}`}>{icon}{text}</div>;
}

export default Chip;
